"use client";
import * as React from "react";
import CompanyLogos from "./CompanyLogos";

const CompanySection = () => {
  return (
    <section className="relative z-10 overflow-hidden self-stretch mt-20 py-12 pr-32 pl-32 bg-white max-md:px-5">
      <h2 className="text-lg leading-relaxed text-gray-800 opacity-50">
        Companies we helped grow
      </h2>
      <CompanyLogos />
    </section>
  );
};

export default CompanySection;
